import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import {PAGE_SIZE} from './constants';

export const fetchReports = (
    institutionId: string,
    kinds: string[],
    from: string | undefined,
    to: string | undefined,
    locations: string | undefined,
    childIds: string | undefined,
    reporterIds: string | undefined,
    cursor: string | null,
) => {
    return RESTClient.getAuthenticatedObservable(`v2/accident-reports/overview`, {
        institutionId,
        kinds,
        from,
        to,
        locations,
        childIds,
        reporterIds,
        cursor,
        limit: PAGE_SIZE,
    });
};
